export enum UiStates {
  EMAIL_INPUT = 'EMAIL_INPUT',
  PASSKEY_LOGIN = 'PASSKEY_LOGIN',
  PASSKEY_LOGIN_FAIL = 'PASSKEY_LOGIN_FAIL',
  OTP_INPUT = 'OTP_INPUT',
  PASSKEY_GENERATOR = 'PASSKEY_GENERATOR',
  VEHICLE_MANAGER = 'VEHICLE_MANAGER',
  MANAGE_VEHICLE = 'MANAGE_VEHICLE',
  ADVANCED_TRANSACTION = 'ADVANCED_TRANSACTION',
  SIGN_MESSAGE = 'SIGN_MESSAGE',
  TRANSACTION_SUCCESS = 'TRANSACTION_SUCCESS',
  TRANSACTION_CANCELLED = 'TRANSACTION_CANCELLED',
  VEHICLES_SHARED_SUCCESS = 'VEHICLES_SHARED_SUCCESS',
  ADD_VEHICLE = 'ADD_VEHICLE',
  COMPATIBILITY_CHECK = 'COMPATIBILITY_CHECK',
  MINT_VEHICLE = 'MINT_VEHICLE',
  CONNECT_DEVICE = 'CONNECT_DEVICE',
  CONNECT_TESLA = 'CONNECT_TESLA',
  SUCCESS = 'SUCCESS',
  LOGOUT = 'LOGOUT',
}
